_collow.components.AccountFormSubmit = class AccountFormSubmit extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  token;
  email;
  isCompany;


  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    switch (params.page) {
      case "activate-account":
        this.activateAccount();
        break;
      case "wl-activate":
      case "reset-pw":
        this.checkToken();
      case "forget-pw":
      case "login":
      case "register":
      case "company-register":
      case "reset-pw":
      case "wl-activate":
        this.listen(root, "submit", this.submitHandler);
    }
  }

  activateAccount = () => {
    this.getUrlParams();
    if (this.email && this.token) {
      const formData = new FormData();
      formData.append("encoded_email", this.email);
      formData.append("encoded_activation_code", this.token);
      //create endpoint based on company or user
      const url = `${this.params.path}/${this.isCompany ? "company" : "user"
        }/activate`;
      fetching(url, "put", formData)
        .then(() => {
          this.elements.messageActivated.removeAttribute("hidden")
          setTimeout(() => {
            window.location.href = "/login";
          }, 1500);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  checkToken = () => {
    this.getUrlParams();
    const form = new FormData();
    form.append("encoded_email", this.email);

    const tokenKey = this.params.page === "wl-activate" ? "encoded_activation_code" : "encoded_token";
    form.append(tokenKey, this.token);
    fetching(
      `${this.params.path}/user/${this.params.page == "wl-activate"
        ? "check_activation_token"
        : "check_token"
      }`,
      "post",
      form
    ).catch((err) => _collow.Notify.error(this.params.messageTokenExpiredError, {}))
  };

  getUrlParams = () => {
    const href = window.location.href;
    const url = new URL(href).searchParams;
    this.email = url.get("email");
    this.token = url.get("token");
    this.isCompany = url.get("isCompany")?.toLowerCase() == "true";
  };

  submitHandler = (e) => {
    e.preventDefault();
    this.elements?.submit?.setAttribute("disabled", "");
    const formdata = new FormData(this.root);
    const hasAcceptingTermsCheck = document.querySelector('[data-has-accepting-terms-check]');
    const checkbox = this.root.querySelector("#termsAndConditionsCheckbox");

    if (this.params.page == "reset-pw") {
      formdata.append("encoded_email", this.email);
      formdata.append("encoded_token", this.token);
    }
    if ((this.params.page == "wl-activate") && this.checkPasswords()
    ) {
      formdata.append("encoded_email", this.email);
      formdata.append("encoded_activation_code", this.token);
    } else if (
      !["login", "forget-pw", "reset-pw", "register"].includes(this.params.page)
    ) {
      this.elements?.submit?.removeAttribute("disabled");
      return
    }

    if (this.params.page === "wl-activate" && hasAcceptingTermsCheck && checkbox) {   
      if (!this.checkCheckBox(hasAcceptingTermsCheck, checkbox)) {
        this.elements?.submit?.removeAttribute("disabled");
        return;
      }
    }
    this.elements?.submit?.removeAttribute("disabled");

    if (
      (this.params.page == "register" ||
        this.params.page == "reset-pw" ||
        this.params.page == "company-register") &&
      !this.checkPasswords()
    ) {
      this.elements?.submit?.removeAttribute("disabled");
      return;
    }

    fetching(
      `${this.params.path}/${this.url()}`,
      this.params.page == "wl-activate" ? "put" : "post",
      formdata
    )
      .then((res) => this.onSucces(res))
      .catch((err) => {
        (err == 401) ? _collow.Notify.error(this.params.messageBadLogin) :
          (err == 405) ? _collow.Notify.error(this.params.messageInactiveAccount) :
            (err == 409) ? _collow.Notify.error(this.params.messageAlreadyAccount) :
              (err == 410) ? this.forgetPwSucces() : _collow.Notify.error(this.params.messageSystemError);
        this.elements?.submit?.removeAttribute("disabled");
      });
  };

  /**
   * @returns api call extentsions based on which page
   */
  url = () => {
    switch (this.params.page) {
      case "forget-pw":
        return "user/forgot_password_email";
      case "reset-pw":
        return "user/reset_password";
      case "login":
        return "user/login";
      case "register":
        return "user/register";
      case "company-register":
        return "company/register";
      case "wl-activate":
        return "user/activate_change_password";
      default:
        return "";
    }
  };

  /**
   * comparing two password values, and their accordance to our requirements (i.e. 8 characters, 1 upper etc.)
   * @returns true if values are and have the neccesary requirements.
   */
  checkPasswords = () => {
    if (this.root.password.value !== this.root.password2.value) {
      _collow.Notify.error(this.params.messagePasswordNoMatch, {});
      return false;
    } else if (!(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(this.root.password.value))) { //min 8 characters, 1 upper character and 1 number
      _collow.Notify.error(this.params.messagePasswordNoRequirements, {});
      return false;
    }
    return true
  };

  /**
   * checks if checkox is checked 
   * @returns true if checkbox is checked
   */
  checkCheckBox = (hasAcceptingTermsCheck, checkbox) => {
    if (!this.params.page === "wl-activate" || !hasAcceptingTermsCheck || !checkbox) return true;
    if (!checkbox.checked) {
      _collow.Notify.error(this.params.messageCheckboxNotChecked);
      return false;
    }
    return true
  };

  /**
   * @param {*} result result out of api call
   * handle result based on the kind of page
   */
  onSucces = (result) => {
    switch (this.params.page) {
      case "forget-pw":
        this.forgetPwSucces();
        break;
      case "reset-pw":
        this.resetPwSucces();
        break;
      case "login":
        this.loginSucces(result);
        break;
      case "register":
      case "company-register":
        this.registerSucces();
        break;
      case "wl-activate":
        this.wlActivateSucces();
    }
  };
  forgetPwSucces = () => {
    this.root.email.setAttribute("hidden", "");
    this.elements.button.setAttribute("hidden", "");
    this.elements.succesMessage.removeAttribute("hidden");
  };

  resetPwSucces = () => {
    [this.root.password, this.root.password2, this.elements.submit].forEach(
      (el) => el.setAttribute("hidden", "")
    );
    this.elements.passwordChanged.removeAttribute("hidden");
  };

  /**
   * @param {*} result api call json result
   * get the information json of the current user
   */
  loginSucces = async (result) => {
    if (!result) return;
    const token = `${result["token_type"]} ${result["access_token"]}`;
    window.localStorage.setItem("token", token);
    window.localStorage.setItem("tokenValidTime", result["time_expire"]);
    window.localStorage.setItem("companyAccount", result["company_account"]);
    document.cookie = `_ctt=${result["time_expire"]}; path=/;`;

    const userJson = await fetching(
      `${this.params.path}/${result["company_account"] ? "company/me" : "user/me"
      }`,
      "get"
    ).catch((err) => {
      console.error(err);
      this.elements?.submit?.removeAttribute("disabled");
    });

    localStorage.setItem("progressJson", JSON.stringify(userJson));
    if (!result["company_account"]) document.cookie = `_r=${userJson.role}; path=/;`;

    var isAdmin = userJson.role == 2; // 2 is the admin role
    this.rerouting(isAdmin);
  };

  registerSucces = () => (this.root.innerHTML = this.params.messageAccountMade);

  wlActivateSucces = () => {
    [this.root.password, this.root["password2"], this.elements.submit].forEach(
      (el) => el.setAttribute("hidden", "")
    );
    this.elements.passwordCreated.removeAttribute("hidden");
  };

  /**
   * routing on login. can be to the home page or the first page of the course last visited
   */
  rerouting = (isAdmin = false) => {
    const href = window.location.href;
    const urlParams = new URL(href).searchParams;

    if (isAdmin) {
      window.location.pathname = "/admin";
      return;
    }

    const reroute = urlParams.get("course");

    if (reroute) {
      window.location.pathname = reroute;
      return;
    }
    window.location.pathname = "/";
  };
};
